export default "__VITE_ASSET__B7WEndk1__"